import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chip", {[$options.type]: true}]),
    contenteditable: "false",
    onMouseenter: _cache[1] || (_cache[1] = $event => ($data.hover = true)),
    onMouseleave: _cache[2] || (_cache[2] = $event => ($data.hover = false))
  }, [
    ($data.hover)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "close pointer",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('delete', $props.command)))
        }, [
          _createVNode(_component_Icon, {
            icon: "x",
            size: "1rem",
            stroke: "var(--brand-900)"
          })
        ]))
      : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          icon: $options.icon,
          "stroke-width": "1",
          size: "1.6rem",
          stroke: $options.type === 'source' ? 'var(--blue-700)' : 'var(--brand-500)'
        }, null, 8 /* PROPS */, ["icon", "stroke"])),
    _createTextVNode(" " + _toDisplayString($options.title), 1 /* TEXT */)
  ], 34 /* CLASS, NEED_HYDRATION */))
}